export default {
  // Navbar
  'nav.home': 'Home',
  'nav.about': 'About',
  'nav.services': 'Services',
  'nav.contracts': 'Contracts',
  'nav.profit': 'Profit',
  'nav.video': 'Video',
  'nav.invest': 'INVEST NOW',

  // Hero
  'hero.badge': 'Elon Musk · SpaceX · IPO 2025',
  'hero.title1': 'INVEST IN THE',
  'hero.title2': 'FUTURE',
  'hero.desc': 'Exclusive investment contracts in the SpaceX IPO by Elon Musk. Returns from <strong>20% to 50%</strong> in just <strong>2 working days</strong>. Contracts from <strong>3 000 €</strong>.',
  'hero.cta.primary': 'CHOOSE CONTRACT',
  'hero.cta.secondary': 'Learn More',
  'hero.stat1': 'Max. Return',
  'hero.stat2': 'Top Contract',
  'hero.stat3': 'IPO Year',

  // About
  'about.tag': 'About SpaceX IPO',
  'about.title1': 'COMPANY OF',
  'about.title2': 'THE FUTURE',
  'about.p1': 'SpaceX is Elon Musk\'s aerospace company that revolutionized the space industry. The first private company to deliver astronauts to the ISS, creator of the Starlink internet satellite network and developer of the interplanetary Starship rocket.',
  'about.p2': 'SpaceX IPO is a historic event opening a unique opportunity to become a shareholder in a company valued at over <strong>$200 billion</strong>. Our investment packages allow you to enter the deal with minimal thresholds and guaranteed returns in just <strong>2 working days</strong>.',
  'about.fact1': 'SpaceX Valuation',
  'about.fact2': 'Successful Launches',
  'about.fact3': 'Starlink Satellites',
  'about.fact4': 'Investors Worldwide',
  'about.badge': 'Company Valuation',

  // Services
  'services.tag': 'What We Offer',
  'services.title1': 'OUR',
  'services.title2': 'SERVICES',
  'services.sub': 'Full range of services for comfortable and safe investment in SpaceX IPO',
  'services.s1.title': 'Portfolio Management',
  'services.s1.desc': 'Professional management of your investment portfolio within SpaceX IPO. Continuous monitoring and position optimization.',
  'services.s2.title': 'Legal Protection',
  'services.s2.desc': 'All contracts are legally formalized and protected. Transparent conditions, no hidden fees. Full documentary support.',
  'services.s3.title': 'Analytics & Forecasts',
  'services.s3.desc': 'Weekly portfolio reports. Market analytics, IPO forecasts and expert recommendations.',
  'services.s4.title': 'Personal Manager',
  'services.s4.desc': 'Dedicated personal manager throughout your entire investment period. Available 24/7 for consultations and support.',
  'services.s5.title': 'Fund Insurance',
  'services.s5.desc': 'Your investments are insured. Guaranteed capital protection under adverse market conditions.',
  'services.s6.title': 'Fast Profit Withdrawal',
  'services.s6.desc': 'Receive your profit within 1 working day. Withdraw to bank account or crypto wallet.',

  // Contracts
  'contracts.tag': 'Investment Packages',
  'contracts.title1': 'CHOOSE YOUR',
  'contracts.title2': 'CONTRACT',
  'contracts.sub': 'Three levels of SpaceX IPO participation. Choose the package that matches your goals and capabilities',
  'contracts.duration': '2 working days',
  'contracts.profitlabel': 'Return',
  'contracts.pure': 'net profit',
  'contracts.btn': 'SELECT PACKAGE',
  'contracts.disclaimer': '* Returns are for 2 working days. All contracts are legally formalized. Investments are insured under the contract.',
  'contracts.popular': 'Popular',
  'contracts.starter.f1': 'Minimum entry threshold',
  'contracts.starter.f2': 'Guaranteed return 20%',
  'contracts.starter.f3': 'Instant payouts',
  'contracts.starter.f4': 'Personal manager',
  'contracts.starter.f5': 'Legal registration',
  'contracts.starter.f6': 'Weekly reports',
  'contracts.advanced.f1': 'Optimal risk/reward ratio',
  'contracts.advanced.f2': 'Guaranteed return 30%',
  'contracts.advanced.f3': 'Instant payouts',
  'contracts.advanced.f4': 'VIP personal manager',
  'contracts.advanced.f5': 'Extended legal support',
  'contracts.advanced.f6': 'Real-time market analytics',
  'contracts.advanced.f7': 'Investment insurance',
  'contracts.premium.f1': 'Maximum return',
  'contracts.premium.f2': 'Guaranteed return 50%',
  'contracts.premium.f3': 'Instant payouts',
  'contracts.premium.f4': 'Dedicated manager 24/7',
  'contracts.premium.f5': 'Full legal & tax support',
  'contracts.premium.f6': 'Priority access to new packages',
  'contracts.premium.f7': 'Insurance + return guarantee',
  'contracts.premium.f8': 'Exclusive IPO insights',

  // Profit
  'profit.tag': 'Financial Results',
  'profit.title1': 'YOUR',
  'profit.title2': 'PROFIT',
  'profit.sub': 'See how your investments grow in just 2 working days',
  'profit.calc.title': 'PROFIT CALCULATOR',
  'profit.calc.invested': 'Invested',
  'profit.calc.profit': 'Profit',
  'profit.calc.total': 'Total',
  'profit.chart.title': 'GROWTH DYNAMICS',
  'profit.chart.sub': 'Forecast for all packages, 2 working days',
  'profit.max.title': 'MAXIMUM PROFIT',
  'profit.max.sub': 'with Premium package 10 000 €',

  // Footer
  'footer.nav': 'NAVIGATION',
  'footer.legal': 'LEGAL',
  'footer.desc': 'Exclusive opportunity to invest in SpaceX IPO. Join the space revolution with guaranteed returns from 20% to 50% in just 2 working days.',
  'footer.terms': 'Terms of Service',
  'footer.privacy': 'Privacy Policy',
  'footer.tax': 'Tax Information',
  'footer.copy': '© 2025 SpaceX IPO. All rights reserved.',
  'footer.disclaimer': 'Investments carry risk. Past returns do not guarantee future results.',

  // Live toast
  'toast.earned': 'earned',
  'toast.in': 'in',
  'toast.days': '2 working days',

  // Video section
  'video.tag': 'Space News',
  'video.title1': 'NASA LUNAR',
  'video.title2': 'MISSION',
  'video.sub': 'NASA launches the first crewed lunar mission in half a century — a new era of space exploration begins',
  'video.source': 'Euronews Bulgaria',
  'video.headline1': 'NASA sends astronauts to the Moon with Artemis II mission',
  'video.date1': 'Euronews Bulgaria · April 2026',
  'video.headline2': 'Artemis II will fly to the Moon on a 10-day journey',
  'video.date2': 'Euronews Bulgaria · April 2026',
  'video.headline3': 'NASA launches first crewed lunar mission in half a century — Darik News report',
  'video.date3': 'Darik News · April 2026',
  'video.readmore': 'Read full article on Darik News',
  'video.card1': 'SpaceX Starship — the rocket powering the new lunar mission',
  'video.card2': 'First crewed Moon landing since Apollo 17 in 1972',
  'video.card3': 'Historic IPO event tied to SpaceX\'s lunar program success',
};